import { faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useState } from "react";
import { Alert, Button, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import type { ReportDataFragment, ReportInput } from "../types/graphql/graphql";
import { ReportForm } from "./ReportForm";
import { ReportItem } from "./ReportItem";

export type ReportsTabMode = "list" | "reporting";

type CampsiteReportsProps = {
  onReport?: (report: ReportInput) => void;
  reports: ReportDataFragment[];
  campsiteId: number;
  mode: ReportsTabMode;
  onModeChange: (mode: ReportsTabMode) => void;
};

export function CampsiteReports({ reports, campsiteId, mode, onModeChange }: CampsiteReportsProps) {
  const { t } = useTranslation();
  const [reportSubmitted, setReportSubmitted] = useState<boolean>(false);
  const handleSubmit = useCallback(() => {
    onModeChange("list");
    setReportSubmitted(true);
  }, [onModeChange]);

  return mode === "reporting" ? (
    <Card.Body>
      <ReportForm campsiteId={campsiteId} onSubmit={handleSubmit} onCancel={() => onModeChange("list")} />
    </Card.Body>
  ) : (
    <Card.Body>
      {reportSubmitted === true && (
        <Alert variant="success">
          {t("flash.actions.create.notice", { resource_name: t("activerecord.models.report.one") })}
        </Alert>
      )}
      <Alert variant="warning">
        <p>{t("public.campsites.tabs.report.hint")}</p>
        <div className="text-end mt-2">
          <Button onClick={() => onModeChange("reporting")} variant="primary">
            <FontAwesomeIcon icon={faWarning} /> {t("public.campsites.tabs.report.add_report")}
          </Button>
        </div>
      </Alert>
      {reports.map((report) => (
        <ReportItem key={report.id} report={report} />
      ))}
    </Card.Body>
  );
}
